import { render, staticRenderFns } from "./accessControlTime.vue?vue&type=template&id=10e920b1"
import script from "./accessControlTime.vue?vue&type=script&lang=js"
export * from "./accessControlTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports